// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22LW2","badges":"styles_badges__MGdds"};